export default function getEndpoint(path, production = false) {
  let endpoint = null;
  if (process.env.NODE_ENV === "development" && !production) {
    endpoint = "http://3.1.190.110:8080/https://villa.kitchen";
  } else {
    if (process.env.VUE_APP_MODE === "master") {
      endpoint = "https://shop.villamarket.com";
    } else if (process.env.VUE_APP_MODE === "feature") {
      endpoint = "https://dev.villamarket.net";
    } else {
      endpoint = "https://villa.kitchen";
    }
  }
  return endpoint + path;
}

export const SOURCE_AMEX =
  "https://ap-gateway.mastercard.com/checkout/version/61/checkout.js";

export const SOURCE_AMEX_V2 =
  "https://ap-gateway.mastercard.com/static/checkout/checkout.min.js";

// Mastercard Gateway self-hosted card form (same merchant as villa-market)
export const MASTERCARD_MERCHANT_ID = "VL206806648";

export const SOURCE_MASTERCARD_SESSION =
  `https://ap-gateway.mastercard.com/form/version/100/merchant/${MASTERCARD_MERCHANT_ID}/session.js`;

export const SOURCE_MASTERCARD_3DS =
  "https://ap-gateway.mastercard.com/static/threeDS/1.3.0/three-ds.min.js";
